import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import TargetGroupWidget from '../../../widgets/basicProjectInfo/targetSetting/TargetGroupWidget'
import ThePointWidget from '../../../widgets/basicProjectInfo/targetSetting/ThePointWidget'
import ChkAreaSettingWidget from '../../../widgets/basicProjectInfo/targetSetting/ChkAreaSettingWidget'
import AdministrativeAreaWidget from '../../../widgets/basicProjectInfo/targetSetting/AdministrativeAreaWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { getSubProjectAllTargetData } from '../../../redux/actions/targetSetting'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function TargetSetting(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load TargetSetting project id', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getSubProjectAllTargetData(proposalId)
      // console.log('_schema => ', _schema)
      setSchemas(_schema)
      setIsEditWidget({
        targetGroup:
          _schema?.forms?.targetGroup?.criteriaList?.optionSelected?.length > 0 ? false : true,
        targetIssue:
          _schema?.forms?.targetIssue?.issues?.optionSelected?.length > 0 ||
          _schema?.forms?.targetIssue?.issues?.inputOther?.value
            ? false
            : true,
        targetSetting:
          _schema?.forms?.targetSetting?.areaSetting?.optionSelected?.length > 0 ||
          _schema?.forms?.targetSetting?.areaSetting?.inputOther?.value ||
          _schema?.forms?.targetSetting?.areaSetting?.disabledAllCheckbox?.value
            ? false
            : true,
        targetArea: _schema?.forms?.targetArea?.areaList?.value?.length > 0 ? false : true,
      })
      let targetGroup = _schema?.forms?.targetGroup ? !_schema.forms.targetGroup.disabled : true
      let targetIssue = _schema?.forms?.targetIssue ? !_schema.forms.targetIssue.disabled : true
      let targetSetting = _schema?.forms?.targetSetting
        ? !_schema.forms.targetSetting.disabled
        : true
      let targetArea = _schema?.forms?.targetArea ? !_schema.forms.targetArea.disabled : true
      setShowEditAll(targetGroup && targetIssue && targetSetting && targetArea)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isNewSubProject>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          />
        )}

        {schemas?.forms?.targetGroup && (
          <>
            <TargetGroupWidget
              showCommandButton={!schemas.forms.targetGroup.disabled}
              schema={schemas.forms.targetGroup}
              isEdit={isEditWidget.targetGroup}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('targetGroup', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}

        {schemas?.forms?.targetIssue && (
          <>
            <ThePointWidget
              showCommandButton={!schemas.forms.targetIssue.disabled}
              schema={schemas.forms.targetIssue}
              isEdit={isEditWidget.targetIssue}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('targetIssue', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}

        {schemas?.forms?.targetSetting && (
          <>
            <ChkAreaSettingWidget
              showCommandButton={!schemas.forms.targetSetting.disabled}
              schema={schemas.forms.targetSetting}
              isEdit={isEditWidget.targetSetting}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('targetSetting', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}

        {schemas?.forms?.targetArea && (
          <>
            <AdministrativeAreaWidget
              showCommandButton={!schemas.forms.targetArea.disabled}
              schema={schemas.forms.targetArea}
              isEdit={isEditWidget.targetArea}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('targetArea', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
